module.exports = __webpack_public_path__ + "static/media/tinywow_3021Platanegruppe_colored_55475819.19064e49.jpg";